<div class="page">
    <section class="section-account parallax bg-11" style="background-image:url(assets/images/header-1.jpg)">
        <div class="awe-overlay"></div>
        <div class="container">
            <div class="login-register">
                <div>
                    <form [formGroup]="registerForm" (submit)="register()" class="account_form">

                        <h2 class="text text-center">CREATE USER ACCOUNT</h2>

                        <fieldset>
                            <legend>

                                <label>Email Address:
                                    <small style="color:red">*</small>
                                </label>
                                <span *ngIf="registerForm.get('email').touched && registerForm.get('email').invalid">
                                    <small style="color:red">Email is required and has to be like "john@doe.com"</small>
                                </span>
                                <input type="email" formControlName="email" class="field-text">

                                <label>Password:
                                    <small style="color:red">*</small>
                                </label>
                                <!-- <span *ngIf="registerForm.get('password').invalid && (registerForm.get('password').value !== registerForm.get('confirmPassword').value)">
                                    <small style="color:red">Passwords do not match</small>
                                    <br />
                                </span> -->
                                <span *ngIf="registerForm.get('password').touched && registerForm.get('password').invalid">
                                    <small style="color:red">Password must be at least 6 characters</small>
                                </span>
                                <input type="password" formControlName="password" class="field-text">

                                <label>Confirm Password:
                                    <small style="color:red">*</small>
                                </label>
                                <span *ngIf="registerForm.get('confirmPassword').touched && (registerForm.get('password').value !== registerForm.get('confirmPassword').value)">
                                    <small style="color:red">Passwords do not match</small>
                                    <br />
                                </span>
                                <span *ngIf="registerForm.get('confirmPassword').touched && registerForm.get('confirmPassword').invalid">
                                    <small style="color:red">Password must be at least 6 characters</small>
                                </span>
                                <input type="password" formControlName="confirmPassword" class="field-text">
                            </legend>
                        </fieldset>

                        <div>
                            <span *ngIf="errorMessage$ | async as error" style="color:red">{{error}}</span>
                            <button class="awe-btn awe-btn-13" [disabled]="registerForm.invalid || (loading$ | async)">
                                Create Account
                                <i *ngIf="loading$ | async" class="fas fa-spinner fa-pulse"></i>
                            </button>
                            <a [routerLink]="['/login']">Already created an account? Click here to Login</a>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </section>
</div>


// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/core/components/full-register/full-register.component.html